import L from "leaflet";
import iconTruck from "./img/icons8-truck-48.png";
import iconBlue from "./img/marker-icon-2x-blue.png";
import iconGreen from "./img/marker-icon-2x-green.png";
import iconRed from "./img/marker-icon-2x-red.png";
import iconOrange from "./img/marker-icon-2x-orange.png";
import iconYellow from "./img/marker-icon-2x-yellow.png";
import iconGrey from "./img/marker-icon-2x-grey.png";
import iconViolet from "./img/marker-icon-2x-violet.png";
import iconGold from "./img/marker-icon-2x-gold.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

export const statusIcons = {
  Открыта: iconBlue,
  Закрыта: iconGreen,
  "Не доставлено": iconRed,
  "Не доставлен": iconRed,
  "В процессе": iconOrange,
  Ожидает: iconYellow,
};

export const truckIcon = new L.Icon({
  iconUrl: iconTruck,
  iconSize: [48, 48],
  iconAnchor: [24, 24],
  popupAnchor: [0, -24],
});

export const getStatusColor = (status) => {
  switch (status) {
    case "Открыта":
      return "blue";
    case "Закрыта":
      return "green";
    case "Не доставлено":
    case "Не доставлен":
      return "red";
    case "В процессе":
      return "orange";
    case "Ожидает":
      return "goldenrod";
    default:
      return "gray";
  }
};

export const createMarkerIcon = (url) =>
  new L.Icon({
    iconUrl: url || iconGrey,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
